enum ACTIONS {
    CREATE_BUSINESS_UNIT = '[BUSINESS_UNIT] - CREATE',
    CREATE_BUSINESS_UNIT_VALUES = '[BUSINESS_UNIT] - CREATE VALUES',
    BACKGROUND_CREATE_BUSINESS_UNIT_VALUES = '[BUSINESS_UNIT][BACKGROUND] CREATE VALUES',

    FETCH_ALL_BUSINESS_UNITS = '[BUSINESS_UNIT] - FETCH_ALL',
    FETCH_BUSINESS_UNIT = '[BUSINESS_UNIT] - FETCH',
    FETCH_BUSINESS_UNIT_CONCEPT = '[BUSINESS_UNIT] - FETCH_CONCEPT',
    FETCH_BUSINESS_UNIT_VALUES = '[BUSINESS_UNIT] - FETCH_RECORD_VALUES',
    FETCH_BUSINESS_UNITS_VALUES = '[BUSINESS_UNIT] - FETCH_RECORDS_VALUES',
    FETCH_BUSINESS_UNITS_OVERVIEW_PAGE = '[BUSINESS_UNIT] Overview page',
    
    UPDATE_BUSINESS_UNIT = '[BUSINESS_UNIT] - UPDATE',
    UPDATE_BUSINESS_UNIT_VALUES = '[BUSINESS_UNIT] - UPDATE VALUES',
    BACKGROUND_UPDATE_BUSINESS_UNIT_VALUES = '[BUSINESS_UNIT][BACKGROUND] UPDATE VALUES',
    UPSERT_BUSINESS_UNITS_VALUES = '[BUSINESS_UNIT] UPSERT VALUES',

    DELETE_BUSINESS_UNIT = '[BUSINESS_UNIT] - DELETE'
}

export default ACTIONS;

export enum CREATE_BUSINESS_UNIT {
    REQUEST = 'CREATE_BUSINESS_UNIT_REQUEST',
    SUCCESS = 'CREATE_BUSINESS_UNIT_SUCCESS',
    FAILURE = 'CREATE_BUSINESS_UNIT_FAILURE'
}

export enum FETCH_ALL_BUSINESS_UNIT {
    REQUEST = 'FETCH_ALL_BUSINESS_UNIT_REQUEST',
    SUCCESS = 'FETCH_ALL_BUSINESS_UNIT_SUCCESS',
    FAILURE = 'FETCH_ALL_BUSINESS_UNIT_FAILURE'
}

export enum FETCH_BUSINESS_UNIT {
    REQUEST = 'FETCH_BUSINESS_UNIT_REQUEST',
    SUCCESS = 'FETCH_BUSINESS_UNIT_SUCCESS',
    FAILURE = 'FETCH_BUSINESS_UNIT_FAILURE'
}

export enum SAVE_BUSINESS_UNIT {
    REQUEST = 'SAVE_BUSINESS_UNIT_REQUEST',
    SUCCESS = 'SAVE_BUSINESS_UNIT_SUCCESS',
    FAILURE = 'SAVE_BUSINESS_UNIT_FAILURE'
}

export enum SAVE_BUSINESS_UNIT_STATUS {
    REQUEST = 'SAVE_BUSINESS_UNIT_STATUS_REQUEST',
    SUCCESS = 'SAVE_BUSINESS_UNIT_STATUS_SUCCESS',
    FAILURE = 'SAVE_BUSINESS_UNIT_STATUS_FAILURE'
}

export enum BUSINESS_UNIT {
    EDIT = 'BUSINESS_EDIT',
    RESET = 'BUSINESS_RESET'
}

export enum FETCH_BUSINESS_UNIT_DATASET {
    REQUEST = 'FETCH_BUSINESS_UNIT_DATASET_REQUEST',
    SUCCESS = 'FETCH_BUSINESS_UNIT_DATASET_SUCCESS',
    FAILURE = 'FETCH_BUSINESS_UNIT_DATASET_FAILURE'
}